import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=3097ffc2"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=3097ffc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports